import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faArrowUp,
    faBell,
    faBolt,
    faBurn,
    faChartArea,
    faChartBar,
    faCheckSquare,
    faClock,
    faCloud,
    faCodeBranch,
    faColumns,
    faCompress,
    faCopy,
    faDownload,
    faEllipsisH,
    faEllipsisV,
    faExchangeAlt,
    faExternalLinkAlt,
    faEye,
    faFileArchive,
    faFileExport,
    faFilter,
    faFile,
    faFolder,
    faCog,
    faHdd,
    faInfoCircle,
    faLaptop,
    faList,
    faLink,
    faLock,
    faMinusSquare,
    faPause,
    faPen,
    faPlay,
    faPlus,
    faPlusSquare,
    faQuestion,
    faShareAlt,
    faSitemap,
    faStream,
    faTags,
    faTools,
    faTrash,
    faTrashRestore,
    faExclamationTriangle,
    faUndo,
    faUserLock,
    faWrench,
} from "@fortawesome/free-solid-svg-icons";

library.add(
    faArrowUp,
    faBell,
    faBolt,
    faBurn,
    faChartArea,
    faChartBar,
    faCheckSquare,
    faClock,
    faCloud,
    faCodeBranch,
    faColumns,
    faCompress,
    faCopy,
    faDownload,
    faEllipsisH,
    faEllipsisV,
    faExchangeAlt,
    faExternalLinkAlt,
    faEye,
    faFileArchive,
    faFileExport,
    faFilter,
    faFile,
    faFolder,
    faCog,
    faHdd,
    faInfoCircle,
    faLaptop,
    faLink,
    faList,
    faLock,
    faMinusSquare,
    faPause,
    faPen,
    faPlay,
    faPlus,
    faPlusSquare,
    faQuestion,
    faShareAlt,
    faSitemap,
    faStream,
    faTags,
    faTools,
    faTrash,
    faTrashRestore,
    faExclamationTriangle,
    faUndo,
    faUserLock,
    faWrench
);

export const iconMixin = {
    components: {
        Icon: FontAwesomeIcon,
    },
};

export const iconPlugin = {
    install(Vue) {
        Vue.mixin(iconMixin);
    },
};
